import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function DogFood(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 38 24">
      <path d="M32.374 9.061a6.28 6.28 0 00-3.998-4.678A6.284 6.284 0 0022.5.251a6.183 6.183 0 00-3.75 1.27A6.184 6.184 0 0015 .251a6.282 6.282 0 00-5.87 4.132 6.288 6.288 0 00-4 4.678 3.756 3.756 0 00-3.005 2.953l-2.1 10.487A1.252 1.252 0 001.249 24h35.002a1.25 1.25 0 001.223-1.5l-2.1-10.487a3.756 3.756 0 00-3-2.953zM10.411 6.607c.471-.105.84-.473.945-.947a3.722 3.722 0 012.726-2.798 3.715 3.715 0 013.724 1.184 1.29 1.29 0 001.889 0 3.715 3.715 0 013.724-1.184 3.722 3.722 0 012.726 2.798c.105.474.473.842.944.947A3.752 3.752 0 0129.782 9H7.718a3.752 3.752 0 012.693-2.393zM2.775 21.5l1.798-9c.12-.58.632-1 1.228-.998h25.898a1.25 1.25 0 011.228.998l1.798 9H2.775z"></path>
    </IconSvg>
  );
}
